import { Drawer, IconButton, List, useTheme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import MenuIcon from '@material-ui/icons/Menu';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import RootMenuItem from './RootMenuItem';
import UpStickLogo from '../../components/UpStickLogo';
import { graff } from '../../graff';

import { logout, showTest } from '../../actions/app';
import { goToDashboard } from '../../actions/dashboard';
import { showMontages } from '../../actions/montages';
import { showOrders, showUpdateOrderAssets } from '../../actions/orders';
import { goToPacks } from '../../actions/packs';

export const drawerWidthOpen = 240;

const useStyles = makeStyles((theme) => ({
  menuButton: {
    color: graff.color.muted,
    '&:hover': {
      backgroundColor: graff.color.hover,
    },
  },
  hide: {
    display: 'none',
  },
  // The logo and the open/close button.
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '18px 6px 14px 18px',
  },
  headerClosed: {
    flexDirection: 'column',
    gap: 10,
    padding: '18px 0 8px',
  },
  drawer: {
    width: drawerWidthOpen,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidthOpen,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
  },
  content: {
    composes: 'flexColumn spaceBetween flex1',
  },
  list: {
    composes: 'stretchSelf',
    padding: '8px 10px',
  },
  spacer: {
    height: 8,
  },
  footer: {
    borderTop: `1px solid ${graff.color.border}`,
  },
}));

const Menu = (props) => {
  // state
  const [open, setOpen] = useState(true);

  // props
  const { pathName } = props;

  // styles
  const classes = useStyles(props);

  const theme = useTheme();
  const dispatch = useDispatch();
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const _showMenu = (menuName) => {
    switch (menuName) {
      case 'dashboard':
        goToDashboard();
        break;

      case 'montages':
        showMontages();
        break;

      case 'packs':
        goToPacks();
        break;

      case 'orders':
        showOrders();
        break;

      case 'test':
        showTest();
        break;

      case 'updateOrderAssets':
        showUpdateOrderAssets();
        break;

      case 'edition':
        break;

      default:
        goToDashboard();
        break;
    }
  };

  const _logout = () => {
    dispatch(logout());
  };

  // const user = useSelector(getCurrentUser);

  const MenuItem = ({ name, label, selectedPathName }) => {
    const selected = pathName === selectedPathName || (selectedPathName === '/packs' && !!pathName?.startsWith('/pack-'));
    return <RootMenuItem name={name} label={label} onClick={_showMenu} selected={selected} />;
  };

  return (
    <Drawer
      variant="permanent"
      className={classNames(classes.drawer, {
        [classes.drawerOpen]: open,
        [classes.drawerClose]: !open,
      })}
      classes={{
        paper: classNames({
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        }),
      }}
    >
      {/* -------------- Logo and toggle -------------- */}
      <div className={classNames(classes.header, { [classes.headerClosed]: !open })}>
        <UpStickLogo compact={!open} />
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerOpen}
          className={classNames(classes.menuButton, { [classes.hide]: open })}
        >
          <MenuIcon />
        </IconButton>
        <IconButton onClick={handleDrawerClose} className={classNames(classes.menuButton, { [classes.hide]: !open })}>
          {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </IconButton>
      </div>
      <div className={classes.content}>
        <List className={classes.list}>
          <MenuItem name="dashboard" label="Tableau de bord" selectedPathName="/" />
          <div className={classes.spacer} />

          <MenuItem name="packs" label="Packs" selectedPathName="/packs" />
          <MenuItem name="montages" label="Montages" selectedPathName="/montages" />
          <MenuItem name="orders" label="Commandes" selectedPathName="/orders" />
          {/* <MenuItem name="test" label="Test" selectedPathName="/test" /> */}
          {/* <MenuItem name="updateOrderAssets" label="Divers" selectedPathName="/updateOrderAssets" /> */}
        </List>
        <List className={classNames(classes.list, classes.footer)}>
          {/*---- Logout ----*/}
          <RootMenuItem name="logout" label="Déconnexion" onClick={_logout} />
        </List>
      </div>
    </Drawer>
  );
};

Menu.propTypes = {
  pathname: PropTypes.string,
};

export default Menu;
